@if (route$ | async; as route) {
  <div class="layout-row full gap-sm p-sm">
    @for (segment of route.segments; track segment) {
      <div class="flex-none flex-none">
        <div
          class="layout-col {{ getSegmentClass(segment) }}"
          [matTooltip]="getToolTip(segment?.matchResult)"
        >
          <div class="layout-row gap-sm">
            @for (action of segment.actions; track action) {
              <div class="action">
                <span>{{ action }}</span>
              </div>
            }
          </div>
          <span class="mat-caption">{{
            segment?.workCenterNumber + ' ' + segment?.workCenterName
          }}</span>
        </div>
      </div>
    }
  </div>
}
